import { getContext } from '@/context';

export const PORTFOLIO_APP_TOUCH_POINT = 'com.picsart.apps.genai';

/** The host's touchpoint referrer header, read fresh (no cache). */
export const getTouchpoint = (): string | null => {
  try {
    const headers = getContext().utils.api.getHeaders?.();
    return headers?.['x-touchpoint-referrer'] ?? null;
  } catch {
    return null;
  }
};

/**
 * Non-production surface override: `?touchpoint=portfolio` on the launch URL
 * forces the portfolio surface for E2E. The host reports a route-derived
 * touchpoint (e.g. `create-and-home` for /gen-ai/) that never matches the
 * portfolio one, so tests can't reach it otherwise. The host forwards query
 * params into the SDK location params. Ignored in production.
 */
const hasPortfolioOverride = (): boolean => {
  if (import.meta.env.VITE_NODE_ENV === 'production') return false;
  try {
    const value =
      getContext().general.location.getState?.()?.params?.touchpoint;
    return (Array.isArray(value) ? value[0] : value) === 'portfolio';
  } catch {
    return false;
  }
};

/** Whether the miniapp is running inside the portfolio (gen-ai apps) surface. */
export const isPortfolioApp = (): boolean =>
  hasPortfolioOverride() || getTouchpoint() === PORTFOLIO_APP_TOUCH_POINT;

/** SDK location route contains the gen-ai segment (editor host's gen-ai section). */
export const isGenaiRoute = (): boolean => {
  try {
    const route = getContext().general.location.getState?.()?.route ?? '';
    // eslint-disable-next-line no-restricted-syntax -- canonical source of the surface check; callers use this predicate
    return route.includes('gen-ai');
  } catch {
    return false;
  }
};
